import { sql } from 'drizzle-orm'
import { index, integer, sqliteTable, text } from 'drizzle-orm/sqlite-core'

import { id } from './_columns'

// Two-factor sign-in (#227). The same three tables as in bak-accounts; @bak/shared-utils' twoFactorStore reads and
// writes them with plain statements. subject_id is the person's id in this database.

const createdAt = () =>
  text('created_at')
    .notNull()
    .default(sql`(strftime('%Y-%m-%dT%H:%M:%fZ','now'))`)

/**
 * One row per authenticator. `kind` = `totp` (an authenticator app); passkeys can be added later as another kind, with
 * their credential id in `credential_id` and the public key in `secret`. A TOTP key is sealed with TOTP_ENCRYPTION_KEY;
 * `confirmed_at` stays null until the first code is entered, and `last_used_step` stops a code being used twice.
 */
export const mfaFactors = sqliteTable(
  'mfa_factors',
  {
    id: id(),
    subjectId: text('subject_id').notNull(),
    kind: text('kind').notNull(),
    secret: text('secret').notNull(),
    credentialId: text('credential_id'),
    label: text('label'),
    lastUsedStep: integer('last_used_step'),
    lastUsedAt: text('last_used_at'),
    confirmedAt: text('confirmed_at'),
    createdAt: createdAt(),
  },
  (t) => [index('ix_mfa_factors_subject').on(t.subjectId)],
)

/** Ten recovery codes per person, shown once; only their SHA-256 is kept and each works once. */
export const mfaRecoveryCodes = sqliteTable(
  'mfa_recovery_codes',
  {
    id: id(),
    subjectId: text('subject_id').notNull(),
    codeHash: text('code_hash').notNull(),
    usedAt: text('used_at'),
    createdAt: createdAt(),
  },
  (t) => [index('ix_mfa_recovery_codes_subject').on(t.subjectId)],
)

/** The step between a correct password and the code: SHA-256 of the token in an HttpOnly cookie, 5 minutes, used once. */
export const mfaChallenges = sqliteTable(
  'mfa_challenges',
  {
    id: id(),
    subjectId: text('subject_id').notNull(),
    scope: text('scope').notNull().default(''),
    expiresAt: text('expires_at').notNull(),
    usedAt: text('used_at'),
    createdAt: createdAt(),
  },
  (t) => [index('ix_mfa_challenges_expires_at').on(t.expiresAt)],
)
